import React, { Component } from "react";
import Api from "Api/Api";
import { Popup } from "devextreme-react";
import MailForm from "components/AdminComponents/MailForm";
import { connect } from "react-redux";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { confirm } from "devextreme/ui/dialog";
import Paginator from "components/common/Paginator";

class MailingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mails: [],
      visible: false,
      count: 0,
    };
    this.togglePopup = () => {
      this.setState({
        visible: !this.state.visible,
      });
    };
    this.mailCreated = (data) => {
      this.setState({ mails: [...this.state.mails, data], visible: false });
    };
    this.deleteMail = (mailID) => {
      let result = confirm(
        "Do you want to delete this mail, it can't be <b>reverted</b> ?",
        "Confirm"
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          Api.deleteMails(mailID).then((response) => {
            this.setState({
              mails: this.state.mails.filter((mail) => {
                return mail.id !== mailID;
              }),
            });
          });
        }
      });
    };
    this.loadData = (page = 1) => {
      this.props.dispatch({ type: "toggleLoad" });
      Api.getMails(page).then((response) => {
        if (response.status === 200) {
          this.props.dispatch({
            type: "toggleLoad",
          });
          this.setState({
            mails: response.data.results,
            count: response.data.count,
          });
        }
      });
    };
  }
  componentDidMount() {
    this.loadData();
    this.props.dispatch({
      type: "SectionSelected",
      payload: "Compose",
    });
  }

  render() {
    return (
      <>
        {/* <Mails /> */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header card-header-info">
                <div className="ct-chart" id="completedTasksChart">
                  <div className="row">
                    <div className="col-lg-9">
                      <div style={{ textTransform: "capitalize" }}>
                        <h4>Mails</h4>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <i
                        className="material-icons pointer float-right"
                        onClick={this.togglePopup}
                      >
                        add_box
                      </i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <DataGrid dataSource={this.state.mails} keyExpr={"id"}>
                  <Column dataField="from_email" />
                  <Column dataField="recipient_type" caption={"To"} />
                  <Column dataField="subject" />
                  <Column dataField="scheduled" />
                  <Column dataField="repeat" />
                  <Column
                    cellRender={(row) => {
                      return (
                        <span
                          className="badge badge-pill badge-danger"
                          onClick={() => this.deleteMail(row.key)}
                        >
                          Delete
                        </span>
                      );
                    }}
                  />
                </DataGrid>
                <Paginator
                  totalItemsCount={this.state.count}
                  pageRangeDisplayed={5}
                  onChange={(page) => {
                    this.loadData(page);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <MailForm
          mailCreated={this.mailCreated}
          hidePopup={this.togglePopup}
          instantMailSent={null}
          visible={this.state.visible}
        />
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    section: state.section,
  };
}
export default connect(mapStateToProps)(MailingList);
